module.exports = __webpack_public_path__ + "static/media/Fix.0b04c421.pdf";